import { useMemo } from "react";
import { useCommissionParties } from "@/hooks/queries/useCommissionParties";
import { useCommissions } from "@/hooks/queries/useCommissions";
import { useCommissionTypes } from "@/hooks/queries/useCommissionTypes";
import {
  filterCommissions,
  getCommissionMetrics,
  getTypeLabel,
} from "../commission-calculations";

export function useCommissionsPageData(filters: { typeFilter: string; search: string }) {
  const { data: types = [] } = useCommissionTypes();
  const { data: commissions = [], isLoading } = useCommissions({ type: filters.typeFilter });
  const { data: parties = {} } = useCommissionParties(commissions);

  const filteredCommissions = useMemo(
    () => filterCommissions({ commissions, parties, search: filters.search, types }),
    [commissions, filters.search, parties, types],
  );
  const metrics = useMemo(() => getCommissionMetrics(commissions), [commissions]);
  const typeLabel = useMemo(() => (code: string) => getTypeLabel(types, code), [types]);

  return {
    types,
    commissions,
    filteredCommissions,
    parties,
    metrics,
    typeLabel,
    isLoading,
  };
}
